/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Аргументы для обновления push-токена при pushsubscriptionchange.
 * Анонимный endpoint — авторизация через знание предыдущего токена.
 * @export
 * @interface FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs
 */
export interface FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs {
    /**
     * Предыдущий токен (JSON-строка PushSubscription). Может быть null в Firefox.
     * @type {string}
     * @memberof FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs
     */
    OldToken?: string | null;
    /**
     * Новый токен (JSON-строка PushSubscription)
     * @type {string}
     * @memberof FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs
     */
    NewToken: string;
}

/**
 * Check if a given object implements the FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs interface.
 */
export function instanceOfFxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs(value: object): value is FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs {
    if (!('NewToken' in value) || value['NewToken'] === undefined) return false;
    return true;
}

export function FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsFromJSON(json: any): FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs {
    return FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsFromJSONTyped(json, false);
}

export function FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs {
    if (json == null) {
        return json;
    }
    return {
        
        'OldToken': json['OldToken'] == null ? undefined : json['OldToken'],
        'NewToken': json['NewToken'],
    };
}

export function FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsToJSON(json: any): FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs {
    return FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsToJSONTyped(json, false);
}

export function FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgsToJSONTyped(value?: FxIdApplicationPushNotificationsTokensRefreshRefreshPushTokenArgs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'OldToken': value['OldToken'],
        'NewToken': value['NewToken'],
    };
}

